import React from 'react';
import { Button, Tab, Responsive } from 'semantic-ui-react';
import MobilityList from './MobilityList';
import MobilityGrades from './MobilityGrades';
import MobilityCourses from './MobilityCourses';
import StudentMobilityIntership from './StudentMobilityInternship';


export default class MobilityDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            student: JSON.parse(localStorage.getItem('student')),
            mob: JSON.parse(localStorage.getItem('mob')),
            step: false,
        };
    }

    render() {
        const panes = [
            {
                menuItem: 'Ocjene',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <MobilityGrades limitation={this.props.limitation} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Praksa',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudentMobilityIntership limitation={this.props.limitation} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Predmeti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <MobilityCourses limitation={this.props.limitation} />
                </Tab.Pane>)
            },
        ];

        if (this.state.step === true) {
            return (<MobilityList limitation={this.props.limitation} />);
        }

        return (<div>
            <Tab
                panes={panes}
                menu={{
                    secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                }}
                grid={{ paneWidth: 14, tabWidth: 2 }}
            />
            <br />
            <Button
                color="blue"
                floated="left"
                basic="true"
                onClick={() => { this.setState({ step: true }); }}
            >Nazad
            </Button>
            <br />
            <br />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/MobilityDetails.js